import { useCallback, useEffect } from 'react';
import { eventSystem as window } from './event-system';
export function useEvent(type, onEvent) {
    useEffect(function () {
        if (!onEvent)
            return;
        window.addEventListener(type, onEvent);
        return function () {
            window.removeEventListener(type, onEvent);
        };
    }, [type, onEvent]);
    var dispatchEvent = useCallback(function (data) {
        dispatch(type, data);
    }, [type]);
    return dispatchEvent;
}
export function dispatch(type, data) {
    var event = Object.assign(typeof Event === 'function' ? new Event(type) : { type: type }, data);
    window.dispatchEvent(event);
}
export default useEvent;
//# sourceMappingURL=use-event.js.map